import { useQuery } from '@fv/client-core'
import type { ReportSettings } from '@fv/models/admin'

import { adminFetch } from '@/utils'

async function fetchReportSettings(): Promise<ReportSettings> {
  return adminFetch(`/reports/settings`)
}

export function useReportSettings() {
  return useQuery(['report-settings'], fetchReportSettings, {
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  })
}
